export default "__VITE_ASSET__d98498c1__"